module.exports = __webpack_public_path__ + "img/arrow.ef54bb9c.png";